import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconLessonCalendar: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        opacity="0.4"
        d="M12 5.2997V21.3297C11.83 21.3297 11.65 21.2997 11.51 21.2197L11.47 21.1997C9.55 20.1497 6.2 19.0497 4.03 18.7597L3.74 18.7197C2.78 18.5997 2 17.6997 2 16.7397V4.6597C2 3.4697 2.97 2.5697 4.16 2.6697C6.26 2.8397 9.44 3.8997 11.22 5.0097L11.47 5.1597C11.62 5.2497 11.81 5.2997 12 5.2997Z"
        fill="#52AEFF"
      />
      <path
        d="M22 4.66954V16.7395C22 17.6995 21.22 18.5995 20.26 18.7195L19.93 18.7595C17.75 19.0495 14.39 20.1595 12.47 21.2195C12.34 21.2995 12.18 21.3295 12 21.3295V5.29954C12.19 5.29954 12.38 5.24954 12.53 5.15954L12.7 5.04954C14.48 3.92954 17.67 2.85954 19.77 2.67954H19.83C21.02 2.57954 22 3.46954 22 4.66954Z"
        fill="#52AEFF"
      />
      <path
        d="M7.75 9.24023H5.5C5.09 9.24023 4.75 8.90023 4.75 8.49023C4.75 8.08023 5.09 7.74023 5.5 7.74023H7.75C8.16 7.74023 8.5 8.08023 8.5 8.49023C8.5 8.90023 8.16 9.24023 7.75 9.24023Z"
        fill="#52AEFF"
      />
      <path
        d="M8.5 12.2402H5.5C5.09 12.2402 4.75 11.9002 4.75 11.4902C4.75 11.0802 5.09 10.7402 5.5 10.7402H8.5C8.91 10.7402 9.25 11.0802 9.25 11.4902C9.25 11.9002 8.91 12.2402 8.5 12.2402Z"
        fill="#52AEFF"
      />
    </Icon>
  );
};

export default IconLessonCalendar;
